package com.tixforgigs.common.core.extensions

import com.tixforgigs.common.core.util.LocalizationUtil.currentTranslationLocale
import com.tixforgigs.common.core.util.SupportedTranslationLanguages
import de.comahe.i18n4k.Locale
import kotlinx.datetime.*
import kotlinx.datetime.format.DayOfWeekNames
import kotlinx.datetime.format.FormatStringsInDatetimeFormats
import kotlinx.datetime.format.byUnicodePattern
import kotlinx.datetime.format.char
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

val DOW_DE_LONG = listOf(
  "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"
)

val DOW_DE_ABBR = listOf(
  "Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"
)

const val PATTERN_DE = "dd.MM.yyyy · HH:mm"
const val PATTERN_SHORT_DE = "dd.MM.yyyy"
const val PATTERN_EN = "dd/MM/yyyy · HH:mm"


@OptIn(ExperimentalTime::class, FormatStringsInDatetimeFormats::class)
fun Instant.eventFormat(tz: String?): String =
  toLocalDateTime(timeZone = TimeZone.of(tz ?: TimeZone.currentSystemDefault().id))
    .format(LocalDateTime.Format {
      byUnicodePattern(PATTERN_DE)
    })

@OptIn(ExperimentalTime::class, FormatStringsInDatetimeFormats::class)
fun Instant.eventFormatMedium(
  tz: String?,
  locale: Locale = currentTranslationLocale.value
): String = toLocalDateTime(timeZone = TimeZone.of(tz ?: TimeZone.currentSystemDefault().id))
  .format(LocalDateTime.Format {
    if (locale == SupportedTranslationLanguages.DE.locale) {
      dayOfWeek(DayOfWeekNames(DOW_DE_ABBR))
      chars(", ")
      byUnicodePattern(PATTERN_DE)
    } else {
      dayOfWeek(DayOfWeekNames.ENGLISH_ABBREVIATED)
      chars(", ")
      byUnicodePattern(PATTERN_EN)
    }
  })

@OptIn(ExperimentalTime::class, FormatStringsInDatetimeFormats::class)
fun Instant.eventFormatLong(
  tz: String?,
  locale: Locale = currentTranslationLocale.value
): String = toLocalDateTime(timeZone = TimeZone.of(tz ?: TimeZone.currentSystemDefault().id))
  .format(LocalDateTime.Format {
    if (locale == SupportedTranslationLanguages.DE.locale) {
      dayOfWeek(DayOfWeekNames(DOW_DE_LONG))
      chars(", ")
      byUnicodePattern(PATTERN_DE)
    } else {
      dayOfWeek(DayOfWeekNames.ENGLISH_FULL)
      chars(", ")
      byUnicodePattern(PATTERN_EN)
    }
  })

//TODO(need timezone as parameter as well?)
@OptIn(ExperimentalTime::class, FormatStringsInDatetimeFormats::class)
fun Instant.orderFormat(withTime: Boolean = false): String = toLocalDateTime(timeZone = TimeZone.currentSystemDefault())
  .format(LocalDateTime.Format {
    if (withTime) {
      byUnicodePattern(PATTERN_DE)
    } else {
      byUnicodePattern(PATTERN_SHORT_DE)
    }
  })

fun LocalTime.sessionFormat(): String = format(
  LocalTime.Format {
    minute()
    char(':')
    second()
  }
)
